var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5961 14.9945L19.6684 11.9189C19.8826 11.7045 20 11.4203 20 11.1193C20 10.8183 19.8826 10.5341 19.6684 10.3197C19.2413 9.89343 18.4994 9.89343 18.0723 10.3197L15 13.3966L11.9265 10.3197C11.4994 9.89343 10.7574 9.89343 10.3303 10.3197C10.1174 10.5341 10 10.8183 10 11.1193C10 11.4203 10.1174 11.7045 10.3303 11.9189L13.4026 14.9945L10.3303 18.0701C10.1174 18.2846 10 18.5688 10 18.8697C10 19.1707 10.1174 19.4549 10.3303 19.6693C10.7574 20.0956 11.4994 20.0956 11.9265 19.6693L15 16.5924L18.0723 19.6693C18.2865 19.8825 18.569 20 18.871 20C19.1729 20 19.4555 19.8825 19.6684 19.6693C19.8826 19.4549 20 19.1707 20 18.8697C20 18.5688 19.8826 18.2846 19.6684 18.0701L16.5961 14.9945Z",
    fill: "#F70F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderClose);
export default __webpack_public_path__ + "static/media/slider-Close.442e5fc2700318daf381f55a4c5eb8be.svg";
export { ForwardRef as ReactComponent };